/**
 * One clipboard helper, shared by the two screens that hand over a license key.
 *
 * `navigator.clipboard` is unavailable on an insecure origin and can be denied
 * by permission policy. This console is always HTTPS behind Access, so the
 * failure is near-unreachable — but the failure mode is a key that looks copied
 * and is not, and the operator then pastes the previous clipboard entry into a
 * support reply. So the result is reported rather than assumed.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
